var _title, _desc, _g;
var _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgBankingClock = function SvgBankingClock(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "48px",
    viewBox: "0 0 40 48",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Pictogram/Page 4/Step 1")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "QA:-Icons-in-different-colours",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RAK-CO:-Icons-in-different-coloured-versions",
    transform: "translate(-3441.000000, -371.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pictogram/Page-4/Step-1",
    transform: "translate(3441.000000, 371.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,0.0006 C16.552,0.0006 17,0.4486 17,1.0006 C17,1.5506 16.552,2.0006 16,2.0006 L5,2.0006 C3.346,2.0006 2,3.3466 2,5.0006 L2,38.0006 L26,38.0006 L26,29.0006 C26,28.4486 26.448,28.0006 27,28.0006 C27.552,28.0006 28,28.4486 28,29.0006 L28,43.0006 C28,45.7566 25.756,48.0006 23,48.0006 L5,48.0006 C2.242,48.0006 5.32907052e-15,45.7566 5.32907052e-15,43.0006 L5.32907052e-15,5.0006 C5.32907052e-15,2.2426 2.242,0.0006 5,0.0006 L16,0.0006 Z M26,40.0006 L2,40.0006 L2,43.0006 C2,44.6546 3.346,46.0006 5,46.0006 L23,46.0006 C24.654,46.0006 26,44.6546 26,43.0006 L26,40.0006 Z M27,6 C27.552,6 28,6.448 28,7 L28,12 L31,12 C31.552,12 32,12.448 32,13 C32,13.55 31.552,14 31,14 L27,14 C26.448,14 26,13.55 26,13 L26,7 C26,6.448 26.448,6 27,6 Z",
    id: "Combined-Shape",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,2 C20.934,2 16,6.934 16,13 C16,19.064 20.934,24 27,24 C33.066,24 38,19.064 38,13 C38,6.934 33.066,2 27,2 M27,26 C19.832,26 14,20.168 14,13 C14,5.832 19.832,0 27,0 C34.168,0 40,5.832 40,13 C40,20.168 34.168,26 27,26",
    id: "Fill-6",
    fill: "#EB2F16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,42 C14.828,42 15.5,42.672 15.5,43.5 C15.5,44.328 14.828,45 14,45 C13.172,45 12.5,44.328 12.5,43.5 C12.5,42.672 13.172,42 14,42",
    id: "Fill-1",
    fill: "#373737"
  }))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBankingClock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bankingClock.38cff8ae.svg";
export { ForwardRef as ReactComponent };